/** Catálogo compacto de países para el selector de teléfono (sin dependencias). */

export interface Country {
  /** Código ISO 3166-1 alpha-2. */
  iso: string;
  /** Código de marcación sin '+', ej. '52'. */
  dial: string;
  es: string;
  en: string;
  zh: string;
}

/** Favoritos fijados arriba, en este orden. */
export const FAVORITE_ISOS = ['MX', 'US', 'CN'] as const;

export const COUNTRIES: Country[] = [
  { iso: 'MX', dial: '52', es: 'México', en: 'Mexico', zh: '墨西哥' },
  { iso: 'US', dial: '1', es: 'Estados Unidos', en: 'United States', zh: '美国' },
  { iso: 'CN', dial: '86', es: 'China', en: 'China', zh: '中国' },
  { iso: 'DE', dial: '49', es: 'Alemania', en: 'Germany', zh: '德国' },
  { iso: 'SA', dial: '966', es: 'Arabia Saudita', en: 'Saudi Arabia', zh: '沙特阿拉伯' },
  { iso: 'AR', dial: '54', es: 'Argentina', en: 'Argentina', zh: '阿根廷' },
  { iso: 'AU', dial: '61', es: 'Australia', en: 'Australia', zh: '澳大利亚' },
  { iso: 'AT', dial: '43', es: 'Austria', en: 'Austria', zh: '奥地利' },
  { iso: 'BE', dial: '32', es: 'Bélgica', en: 'Belgium', zh: '比利时' },
  { iso: 'BO', dial: '591', es: 'Bolivia', en: 'Bolivia', zh: '玻利维亚' },
  { iso: 'BR', dial: '55', es: 'Brasil', en: 'Brazil', zh: '巴西' },
  { iso: 'CA', dial: '1', es: 'Canadá', en: 'Canada', zh: '加拿大' },
  { iso: 'CL', dial: '56', es: 'Chile', en: 'Chile', zh: '智利' },
  { iso: 'CO', dial: '57', es: 'Colombia', en: 'Colombia', zh: '哥伦比亚' },
  { iso: 'KR', dial: '82', es: 'Corea del Sur', en: 'South Korea', zh: '韩国' },
  { iso: 'CR', dial: '506', es: 'Costa Rica', en: 'Costa Rica', zh: '哥斯达黎加' },
  { iso: 'CU', dial: '53', es: 'Cuba', en: 'Cuba', zh: '古巴' },
  { iso: 'DK', dial: '45', es: 'Dinamarca', en: 'Denmark', zh: '丹麦' },
  { iso: 'EC', dial: '593', es: 'Ecuador', en: 'Ecuador', zh: '厄瓜多尔' },
  { iso: 'EG', dial: '20', es: 'Egipto', en: 'Egypt', zh: '埃及' },
  { iso: 'SV', dial: '503', es: 'El Salvador', en: 'El Salvador', zh: '萨尔瓦多' },
  { iso: 'AE', dial: '971', es: 'Emiratos Árabes Unidos', en: 'United Arab Emirates', zh: '阿联酋' },
  { iso: 'ES', dial: '34', es: 'España', en: 'Spain', zh: '西班牙' },
  { iso: 'FR', dial: '33', es: 'Francia', en: 'France', zh: '法国' },
  { iso: 'GR', dial: '30', es: 'Grecia', en: 'Greece', zh: '希腊' },
  { iso: 'GT', dial: '502', es: 'Guatemala', en: 'Guatemala', zh: '危地马拉' },
  { iso: 'HN', dial: '504', es: 'Honduras', en: 'Honduras', zh: '洪都拉斯' },
  { iso: 'HK', dial: '852', es: 'Hong Kong', en: 'Hong Kong', zh: '中国香港' },
  { iso: 'IN', dial: '91', es: 'India', en: 'India', zh: '印度' },
  { iso: 'ID', dial: '62', es: 'Indonesia', en: 'Indonesia', zh: '印度尼西亚' },
  { iso: 'IE', dial: '353', es: 'Irlanda', en: 'Ireland', zh: '爱尔兰' },
  { iso: 'IL', dial: '972', es: 'Israel', en: 'Israel', zh: '以色列' },
  { iso: 'IT', dial: '39', es: 'Italia', en: 'Italy', zh: '意大利' },
  { iso: 'JP', dial: '81', es: 'Japón', en: 'Japan', zh: '日本' },
  { iso: 'MO', dial: '853', es: 'Macao', en: 'Macao', zh: '中国澳门' },
  { iso: 'MY', dial: '60', es: 'Malasia', en: 'Malaysia', zh: '马来西亚' },
  { iso: 'MA', dial: '212', es: 'Marruecos', en: 'Morocco', zh: '摩洛哥' },
  { iso: 'NI', dial: '505', es: 'Nicaragua', en: 'Nicaragua', zh: '尼加拉瓜' },
  { iso: 'NO', dial: '47', es: 'Noruega', en: 'Norway', zh: '挪威' },
  { iso: 'NZ', dial: '64', es: 'Nueva Zelanda', en: 'New Zealand', zh: '新西兰' },
  { iso: 'NL', dial: '31', es: 'Países Bajos', en: 'Netherlands', zh: '荷兰' },
  { iso: 'PA', dial: '507', es: 'Panamá', en: 'Panama', zh: '巴拿马' },
  { iso: 'PY', dial: '595', es: 'Paraguay', en: 'Paraguay', zh: '巴拉圭' },
  { iso: 'PE', dial: '51', es: 'Perú', en: 'Peru', zh: '秘鲁' },
  { iso: 'PH', dial: '63', es: 'Filipinas', en: 'Philippines', zh: '菲律宾' },
  { iso: 'PL', dial: '48', es: 'Polonia', en: 'Poland', zh: '波兰' },
  { iso: 'PT', dial: '351', es: 'Portugal', en: 'Portugal', zh: '葡萄牙' },
  { iso: 'GB', dial: '44', es: 'Reino Unido', en: 'United Kingdom', zh: '英国' },
  { iso: 'SG', dial: '65', es: 'Singapur', en: 'Singapore', zh: '新加坡' },
  { iso: 'ZA', dial: '27', es: 'Sudáfrica', en: 'South Africa', zh: '南非' },
  { iso: 'SE', dial: '46', es: 'Suecia', en: 'Sweden', zh: '瑞典' },
  { iso: 'CH', dial: '41', es: 'Suiza', en: 'Switzerland', zh: '瑞士' },
  { iso: 'TH', dial: '66', es: 'Tailandia', en: 'Thailand', zh: '泰国' },
  { iso: 'TW', dial: '886', es: 'Taiwán', en: 'Taiwan', zh: '中国台湾' },
  { iso: 'TR', dial: '90', es: 'Turquía', en: 'Turkey', zh: '土耳其' },
  { iso: 'UY', dial: '598', es: 'Uruguay', en: 'Uruguay', zh: '乌拉圭' },
  { iso: 'VE', dial: '58', es: 'Venezuela', en: 'Venezuela', zh: '委内瑞拉' },
  { iso: 'VN', dial: '84', es: 'Vietnam', en: 'Vietnam', zh: '越南' },
];

export type CountryLocale = 'es' | 'en' | 'zh';

export function getCountry(iso: string): Country {
  return COUNTRIES.find(c => c.iso === iso) ?? COUNTRIES[0];
}

export const FAVORITE_COUNTRIES: Country[] = FAVORITE_ISOS.map(getCountry);

/** Resto de países, orden alfabético según el idioma. */
export function otherCountries(locale: CountryLocale): Country[] {
  const fav = new Set<string>(FAVORITE_ISOS);
  const collator = new Intl.Collator(locale);
  return COUNTRIES.filter(c => !fav.has(c.iso)).sort((a, b) => collator.compare(a[locale], b[locale]));
}

/**
 * Detecta el país de un número E.164 por el prefijo más largo. En empate de
 * prefijo gana el primero de la lista (favoritos primero: +1 → Estados Unidos).
 */
export function detectCountry(e164: string): { country: Country; national: string } | null {
  if (!e164.startsWith('+')) return null;
  const digits = e164.replace(/\D/g, '');
  let best: Country | null = null;
  for (const c of COUNTRIES) {
    if (digits.startsWith(c.dial) && (!best || c.dial.length > best.dial.length)) best = c;
  }
  return best ? { country: best, national: digits.slice(best.dial.length) } : null;
}
